import { useState } from "react"
import { btnSecondary } from "./FormComponents"

// Excluido a propósito del patrón optimistic UI: el valor es generado por el
// servidor y no existe hasta que la respuesta llega — no hay nada que aplicar
// de forma anticipada (ver design.md, "Secreto generado por servidor").
export function TempPasswordReveal({ label, value, onDismiss }: { label: string; value: string; onDismiss: () => void }) {
  const [copied, setCopied] = useState(false)
  return (
    <div
      role="status"
      aria-live="polite"
      className="rounded-xl border border-success-300 bg-success-50 p-4 dark:border-success-500/30 dark:bg-success-500/10"
    >
      <p className="text-sm font-medium text-success-700 dark:text-success-400">{label}</p>
      <p className="mt-1 text-xs text-success-600 dark:text-success-500">
        Cópiala y compártela ahora — no se vuelve a mostrar.
      </p>
      <div className="mt-2 flex items-center gap-2">
        <code className="flex-1 truncate rounded-lg bg-white px-3 py-2 text-sm dark:bg-gray-900">{value}</code>
        <button
          type="button"
          className={`min-h-11 ${btnSecondary}`}
          onClick={async () => {
            await navigator.clipboard.writeText(value)
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
          }}
        >
          {copied ? "Copiado" : "Copiar"}
        </button>
        <button type="button" className={`min-h-11 ${btnSecondary}`} onClick={onDismiss}>
          Cerrar
        </button>
      </div>
    </div>
  )
}

export default TempPasswordReveal
